import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import _ from "lodash";

function CommiitteeInfoDetail() {
  const [detailInfo, setDetailInfo] = useState([]);
  const [createAtInfo, setCreateAtInfo] = useState(""); // 작성일 State 타입을 문자열로 미리 할당(undefined 방지)
  const [addFile, setAddFile] = useState([]);
  const [orderNum, setOrderNum] = useState("");
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`/api/committee-meeting-board/${id}`, {
        params: { parentType: "COMMITTEE_MEETING" },
      })
      .then((response) => {
        setDetailInfo(response.data);
        setCreateAtInfo(response.data.createAt);
        let tempData = response?.data?.docs?.filter(
          (el) => el.description !== "meet_resolution"
        );
        let filteredData = _.unionBy(tempData, "description");
        setAddFile(filteredData);
        setOrderNum(response.data.times);
      });
  }, [id]);

  return (
    <div>
      <div>
        <div className="notice_title_wrap">
          <h1 className="notice_title">
            {detailInfo.title}
            <p className="pubic_info">
              <span>
                <strong>회의차수 : {orderNum}</strong>
              </span>
              <span>{createAtInfo.substring(0, 11).replace(/-/g, ".")}</span>
              <span>{detailInfo.createId}</span>
            </p>
          </h1>
        </div>
        <div className="notice_add_file_area">
          <div className="notice_add_file_wrap">
            <h2>첨부파일</h2>
            <div className="notice_addfile_wrap">
              {addFile?.map((docs) => {
                return (
                  <a
                    href={`/api/committee-meeting-board/${id}/doc-down/${docs.id}`}
                    key={docs.id}
                    download
                  >
                    {docs.name}
                  </a>
                );
              })}
            </div>
          </div>
          <div className="notice_content_row">
            <div
              className="jodit-wysiwyg"
              dangerouslySetInnerHTML={{ __html: detailInfo.body }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CommiitteeInfoDetail;
